'use client';
import { useCallback, useRef } from 'react';
import { useConstantCallback } from './useConstantCallback';
const SWIPE_THRESHOLD = 70;
export const useSwipe = ({ onSwipeDown: onSwipeDownFromProps = () => { }, onSwipeUp: onSwipeUpFromProps = () => { }, onSwipeLeft: onSwipeLeftFromProps = () => { }, onSwipeRight: onSwipeRightFromProps = () => { }, springX = false, springY = false, callbacks: { onTouchEnd: onTouchEndFromProps = () => { }, onTouchMove: onTouchMoveFromProps = () => { }, onTouchStart: onTouchStartFromProps = () => { }, } = {}, } = {}) => {
    const initialTouchX = useRef(0);
    const initialTouchY = useRef(0);
    const onSwipeDown = useConstantCallback(onSwipeDownFromProps);
    const onSwipeLeft = useConstantCallback(onSwipeLeftFromProps);
    const onSwipeRight = useConstantCallback(onSwipeRightFromProps);
    const onSwipeUp = useConstantCallback(onSwipeUpFromProps);
    const onTouchStartFromPropsCallback = useConstantCallback(onTouchStartFromProps);
    const onTouchMoveFromPropsCallback = useConstantCallback(onTouchMoveFromProps);
    const onTouchEndFromPropsCallback = useConstantCallback(onTouchEndFromProps);
    const withSpringEffect = springX || springY;
    const onTouchStart = useCallback((event) => {
        const touch = event.changedTouches[0];
        if (!touch) {
            return;
        }
        onTouchStartFromPropsCallback?.(event);
        initialTouchX.current = touch.pageX;
        initialTouchY.current = touch.pageY;
    }, [onTouchStartFromPropsCallback]);
    const onTouchMove = useCallback((event) => {
        const touch = event.changedTouches[0];
        if (!touch || !withSpringEffect) {
            return;
        }
        onTouchMoveFromPropsCallback?.(event);
        const distX = springX ? touch.pageX - initialTouchX.current : 0;
        const distY = springY ? touch.pageY - initialTouchY.current : 0;
        const targetElement = event.currentTarget;
        if (targetElement) {
            targetElement.style.transform = `translate3d(${distX}px, ${distY}px, 0)`;
        }
    }, [withSpringEffect, onTouchMoveFromPropsCallback, springX, springY]);
    const onTouchEnd = useCallback((event) => {
        const touch = event.changedTouches[0];
        if (!touch) {
            return;
        }
        onTouchEndFromPropsCallback?.(event);
        const distX = touch.pageX - initialTouchX.current;
        const distY = touch.pageY - initialTouchY.current;
        const isHorizontalSwipe = Math.abs(distX) >= SWIPE_THRESHOLD && Math.abs(distY) <= SWIPE_THRESHOLD;
        const isVerticalSwipe = Math.abs(distY) >= SWIPE_THRESHOLD && Math.abs(distX) <= SWIPE_THRESHOLD;
        const targetElement = event.currentTarget;
        if (withSpringEffect && targetElement) {
            targetElement.style.transform = '';
        }
        if (isHorizontalSwipe) {
            if (distX < 0) {
                onSwipeLeft();
            }
            else {
                onSwipeRight();
            }
        }
        if (isVerticalSwipe) {
            if (distY > 0) {
                onSwipeDown();
            }
            else {
                onSwipeUp();
            }
        }
        initialTouchY.current = 0;
        initialTouchX.current = 0;
    }, [onSwipeDown, onSwipeLeft, onSwipeRight, onSwipeUp, onTouchEndFromPropsCallback, withSpringEffect]);
    return {
        onTouchEnd,
        onTouchMove,
        onTouchStart,
    };
};
